import Service from '../services/userPin.service'
import { executeAction } from './global.actions'

export const actions = {
  GET_USER_PIN: 'GET_USER_PIN',
  UPDATE_USER_PIN: 'UPDATE_USER_PIN',
}

export const getUserPin = (userId: number) => dispatch => {
  const process = async () => ({
    payload: await Service.getUserPin(userId),
  })
  dispatch(executeAction(actions.GET_USER_PIN, process))
}

export const updateUserPin = (request: PinRequestDTO) => dispatch => {
  const process = async () => ({
    payload: await Service.updateUserPin(request),
  })
  dispatch(executeAction(actions.UPDATE_USER_PIN, process))
}
